var map = {
	"./brl.png": 7831,
	"./da.png": 8128,
	"./de.png": 4578,
	"./el.png": 2331,
	"./en.png": 7143,
	"./es.png": 7144,
	"./fr.png": 6566,
	"./gbp.png": 4062,
	"./hu.png": 6884,
	"./idr.png": 7403,
	"./inr.png": 1341,
	"./it.png": 1468,
	"./ja.png": 7115,
	"./jp.png": 5622,
	"./oz.png": 1914,
	"./pl.png": 4744,
	"./pt.png": 6382,
	"./ru.png": 6449,
	"./sv.png": 9941,
	"./tr.png": 2734,
	"./uz.png": 4840,
	"./zh.png": 7124
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9925;